import { css } from '@emotion/react';
import { Z_INDEX } from '../../constants/zIndex';
import { SIDE_BAR_WIDTH } from '../../constants/sideBarWidth';

const menuStyles = {
    menuButton: css({
        alignItems: 'center',
        display: 'flex',
        cursor: 'pointer',
    }),
    menuButtonWhite: css({
        color: 'white',
    }),
    menuButtonBlack: css({
        color: 'black',
    }),
    menuHeader: css({
        fontSize: 17,
        fontWeight: 700,
        margin: 0,
        textAlign: 'center',
        width: '100%',
    }),
    menuList: css({
        textAlign: 'center',
        transition: '0.3s',
        overflow: 'hidden',
        zIndex: Z_INDEX.MENU_DESKTOP,
        backgroundColor: '#ffffff',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        width: '100%',
        padding: '10px 15px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    }),
    menuListDesktop: css({
        position: 'absolute',
        top: 40,
        right: 40,
        boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
        borderRadius: 8,
        width: `${SIDE_BAR_WIDTH}px`,
        padding: '20px 16px',
    }),
    list: css({
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'start',
        width: '100%',
        padding: 0,
        margin: 0,
        marginBottom: '20px',
    }),
    listElement: css({
        padding: '15px 10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        textDecoration: 'none',
        fontWeight: 500,
        fontSize: 15,
        color: '#000000',
    }),
    link: css({
        textDecoration: 'none',
    }),
    menuFooter: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    }),
    chevronRight: css({
        width: 24,
        height: 24,
    }),
};

export default menuStyles;
